import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ScreenSaverView from '../views/ScreenSaverView.vue'
import IFrameView from '../views/IFrameView.vue'

const routes = [
  {
    path: '/',
    name: 'screensaver',
    component: ScreenSaverView
  },
  {
    path: '/home',
    name: 'home',
    component: HomeView,
    props: {
      buttons: [
        { text: 'Site', route : { name: 'site',  query : { url : 'https://www.choses.ch'}} },
        { text: 'Showreel', route : { name: 'site', query : { url : 'https://vimeo.com/1127797557?autoplay=1'}} },
        { text: 'Shop', route : { name: 'site',  query : { url : 'https://shop.choses.ch'}} },
        { text: 'Projets', route : { name: 'site',  query : { url : 'https://www.des-choses-pareilles.ch/blog'}} },
        { text: 'Muséographie', route : { name: 'site',  query : { url : 'https://www.des-choses-pareilles.ch/museographie'}} },
        { text: 'Stand Promotionnel', route : { name: 'site',  query : { url : 'https://www.des-choses-pareilles.ch/atelier-innovation'}} }
      ]
    }
  },
  {
    path: '/site',
    name: 'site',
    component: IFrameView,
    props: route => ({ iframeUrl: route.query.url })
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router;